import httpService from "app/services/httpService";
import config from "../../../src/config.json";

const apiUrl = config.apiUrl;

const addBank = async (values) => {
  try {
    const { data } = await httpService.post(`${apiUrl}/banks`, values);
    return data;
  } catch (error) {
    console.log(error);
  }
};

const getBankList = async () => {
  try {
    const { data } = await httpService.get(`${apiUrl}/banks`);
    return data;
  } catch (error) {
    console.log(error);
  }
};

const getRequisitionBankList = async () => {
  try {
    const { data } = await httpService.get(`${apiUrl}/banks/requisition-banks`);
    return data;
  } catch (error) {
    console.log(error);
  }
};

const allGetBankList = async () => {
  try {
    const data = await httpService.get(`${apiUrl}/banks/all`);
    return data;
  } catch (error) {
    console.log(error);
  }
};

const bankUpdate = async (id, value) => {
  try {
    const { data } = await httpService.post(
      `${apiUrl}/banks/update/${id}`,
      value
    );
    return data;
  } catch (error) {
    console.log(error);
  }
};

export {
  addBank,
  getBankList,
  getRequisitionBankList,
  allGetBankList,
  bankUpdate,
};
